import { useMemo } from 'preact/hooks'
import omit from 'lodash-es/omit'
import get from 'lodash-es/get'

import CategoryArchive from '../../js/components/page/category-archive'
import { mapNodeToArticle } from '../../js/graphql/utils'
import { buildCategoryPermalink } from '../../js/utils/urls'
import { usePagination } from '../../js/hooks/pagination'
import { CATEGORY } from '../../js/constants'

function Page(props) {
  const { slugs, page, data } = props

  const { category, entries } = useMemo(() => {
    const category = omit(get(data, 'category'), ['posts'])
    const entries = get(data, 'category.posts.nodes', []).map(mapNodeToArticle)

    return {
      category,
      entries,
    }
  }, [data])

  const permalink = buildCategoryPermalink({ slugs })

  const hasNext = get(data, 'category.posts.pageInfo.hasNextPage', false)
  const hasPrev = page > 1

  const rel = usePagination(
    CATEGORY,
    {
      slugs,
      page,
      hasNext,
      hasPrev,
    },
  )

  return (
    <CategoryArchive
      permalink={permalink}
      category={category}
      entries={entries}
      rel={rel}
    />
  )
}

export default Page
